// extracted by mini-css-extract-plugin
export var destinationBox = "boxes-module--destinationBox--fffbe";
export var imgBox = "boxes-module--imgBox--e49c7";
export var serviceBox = "boxes-module--serviceBox--aa116";
export var txtBoxCenter = "boxes-module--txtBoxCenter--868d9";
export var txtBoxDestination = "boxes-module--txtBoxDestination--b1b83";
export var txtBoxLeft = "boxes-module--txtBoxLeft--299ba";
export var txtBoxRight = "boxes-module--txtBoxRight--20083";
export var videoBox = "boxes-module--videoBox--007a6";